// extracted by mini-css-extract-plugin
export default {"successMark":"SMLUpgradeSuccess_successMark__F3Vfn","renewPill":"SMLUpgradeSuccess_renewPill__agVMR"};